import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { ReactMediaGroupNode } from './mediaGroup';
export var lazyMediaGroupView = function lazyMediaGroupView(portalProviderAPI, eventDispatcher, providerFactory) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var api = arguments.length > 4 ? arguments[4] : undefined;
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return ReactMediaGroupNode(portalProviderAPI, eventDispatcher, providerFactory, options, api);
  }
  return withLazyLoading({
    nodeName: 'mediaGroup',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-media-group-lazy-node-view" */
      './mediaGroup').then(function (_ref) {
        var ReactMediaGroupNode = _ref.ReactMediaGroupNode;
        return function (node, view, getPos) {
          return ReactMediaGroupNode(portalProviderAPI, eventDispatcher, providerFactory, options, api)(node, view, getPos);
        };
      });
      return result;
    }
  });
};